document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.js-list-choice-screen')) {
        const list = document.querySelector('.js-list-choice-screen');
        const buttonNext = document.querySelector('.js-choice-next');

        list.addEventListener('click', (e) => {
            e.preventDefault();
            const target = e.target.closest('.js-promocode-choice-screen-link')

            list.querySelectorAll('.is-active').forEach((el) => {
                el.classList.remove('is-active');
            });

            target.classList.add('is-active');

            const queryValue =  target.dataset.href;

            buttonNext.href = queryValue;

        })
    }
});

